export default __webpack_public_path__ + "static/media/IMG8615.7ab369f5.jpg";